import Wrapper from "../../../layout/Wrapper";
import VehicleContractClameComponent from "../../../screens/contractControll/vehicleContract/clame";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Agent Management",
	description: "",
};

export default function AgentManage() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<VehicleContractClameComponent />
		</Wrapper>
	);
}